<template>
  <div class="overflow-x-auto">
    <FlexLayout col :gap="40">
      <!-- 服務項目相關 -->
      <FlexLayout v-if="showControl.block.service" col :gap="12">
        <p>服務項目</p>
        <BobDisplayForm
          :config="{
            rowGap: 12,
            labelWidth: '250px',
          }"
          :fields="displayServiceFields"
        />
      </FlexLayout>

      <FlexLayout
        v-for="item in displayServiceAttachs"
        :key="item.id"
        col
        :gap="12"
      >
        <p>附加服務: {{ item.name }}</p>
        <BobDisplayForm
          :config="{
            rowGap: 12,
            labelWidth: '250px',
          }"
          :fields="item.fields"
        />
      </FlexLayout>

      <!-- 服務人員相關 -->
      <FlexLayout v-if="showControl.block.serviceUnit" col :gap="12">
        <p>服務人員</p>
        <BobDisplayForm
          :config="{
            rowGap: 12,
            labelWidth: '250px',
          }"
          :fields="displayServiceUnitFields"
        />
      </FlexLayout>

      <!-- 設備相關 -->
      <FlexLayout v-if="showControl.block.serviceResource" col :gap="12">
        <p>服務設備</p>
        <BobDisplayForm
          v-if="showControl.block.serviceResource"
          :config="{
            rowGap: 12,
            labelWidth: '250px',
          }"
          :fields="displayServiceResourceFields"
        />
      </FlexLayout>

      <!-- 通用相關 -->
      <FlexLayout col :gap="12">
        <p>時間檢查資訊</p>
        <BobDisplayForm
          :config="{
            rowGap: 12,
            labelWidth: '350px',
          }"
          :fields="displayCommonFields"
        />
      </FlexLayout>
    </FlexLayout>
  </div>
</template>

<script>
import BobDisplayForm from '@/components/BobDisplayForm.vue'
import { filter, isUndefined, map, isEmpty, isNull, get } from 'lodash'

import { computed, defineComponent } from 'vue'
export default defineComponent({
  name: 'AppointmentTimeDebuggerResult',
  components: {
    BobDisplayForm,
  },
  props: {
    resultData: { type: Object, default: () => ({}) },
  },
  setup (props, { emit }) {
    const showControl = computed(() => {
      if (isEmpty(props.resultData)) {
        return { block: { service: false, serviceUnit: false, serviceResource: false } }
      }

      const controls = {
        block: {
          service: !isNull(get(props.resultData, 'appointmentService')),
          serviceUnit: !isNull(get(props.resultData, 'appointmentUnit')),
          serviceResource: !isNull(get(props.resultData, 'resourceItem')),
        },
      }

      return controls
    })

    const displayServiceFields = computed(() => {
      const omitFields = []
      const isPublic = get(props.resultData, 'appointmentService.isPublic')
      const isPubApt = get(props.resultData, 'appointmentService.isPubApt')
      const fields = [
        {
          prop: 'isPublic',
          label: '是否公開顯示',
          body: {
            component: () => import('@/components/Tag/Tag.vue'),
            props: {
              type: isPublic ? 'action' : 'danger',
            },
            render: () => {
              return isPublic ? '是' : '否'
            },
          },
        },
        {
          prop: 'isPubApt',
          label: '是否公開於跨境預約',
          body: {
            component: () => import('@/components/Tag/Tag.vue'),
            props: {
              type: isPubApt ? 'action' : 'danger',
            },
            render: () => {
              return isPubApt ? '是' : '否'
            },
          },
        },
      ]
      if (isNull(isPublic) || isUndefined(isPublic)) {
        omitFields.push('isPublic')
      }
      if (isNull(isPubApt) || isUndefined(isPubApt)) {
        omitFields.push('isPubApt')
      }

      return filter(fields, (field) => {
        return !omitFields.includes(field.prop)
      })
    })

    const displayServiceAttachs = computed(() => {
      return map(get(props.resultData, 'appointmentServiceAttaches'), (item) => {
        return {
          name: item.name,
          id: item.id,
          fields: [
            {
              prop: 'isPublic',
              label: '是否公開顯示',
              body: {
                component: () => import('@/components/Tag/Tag.vue'),
                props: {
                  type: item.isPublic ? 'action' : 'danger',
                },
                render: () => {
                  return item.isPublic ? '是' : '否'
                },
              },
            },
            {
              prop: 'isPubApt',
              label: '是否公開於跨境預約',
              body: {
                component: () => import('@/components/Tag/Tag.vue'),
                props: {
                  type: item.isPubApt ? 'action' : 'danger',
                },
                render: () => {
                  return item.isPubApt ? '是' : '否'
                },
              },
            },
          ],
        }
      })
    })

    const displayServiceUnitFields = computed(() => {
      const omitFields = []

      const isPublic = get(props.resultData, 'appointmentUnit.isPublic')
      const isPubApt = get(props.resultData, 'appointmentUnit.isPubApt')
      const isNotSpecify = get(props.resultData, 'appointmentUnit.isNotSpecify')
      const appointmentUnitTimestockData = get(props.resultData, 'appointmentUnitTimestockData')
      const bookingMax = get(props.resultData, 'appointmentUnitTimestockData.bookingMax')
      const isSchedule = get(props.resultData, 'appointmentUnitTimestockData.isSchedule')
      const scheduleDuration = get(props.resultData, 'appointmentUnitTimestockData.scheduleDuration')
      const isNotBanSchedule = get(props.resultData, 'appointmentUnitTimestockData.isNotBanSchedule')
      const bookingCount = get(props.resultData, 'appointmentUnitTimestockData.bookingCount')
      const isAvailable = get(props.resultData, 'appointmentUnitTimestockData.isAvailable')
      const availableDuration = get(props.resultData, 'appointmentUnitTimestockData.availableDuration')

      const fields = [
        // isPublic
        {
          prop: 'isPublic',
          label: '是否公開顯示',
          body: {
            component: () => import('@/components/Tag/Tag.vue'),
            props: {
              type: isPublic ? 'action' : 'danger',
            },
            render: () => {
              return isPublic ? '是' : '否'
            },
          },
        },
        // isPubApt
        {
          prop: 'isPubApt',
          label: '是否公開於跨境預約',
          body: {
            component: () => import('@/components/Tag/Tag.vue'),
            props: {
              type: isPubApt ? 'action' : 'danger',
            },
            render: () => {
              return isPubApt ? '是' : '否'
            },
          },
        },
        // isNotSpecify
        {
          prop: 'isNotSpecify',
          label: '是否屬於不指定人員',
          body: {
            component: () => import('@/components/Tag/Tag.vue'),
            props: {
              type: isNotSpecify ? 'action' : 'danger',
            },
            render: () => {
              return isNotSpecify ? '是' : '否'
            },
          },
        },
        // bookingMax
        {
          prop: 'bookingMax',
          label: '同時段可服務數量',
          body: {
            component: () => import('@/components/Tag/Tag.vue'),
            props: {
              type: 'success',
            },
            render: () => {
              return bookingMax
            },
          },
        },
        // isSchedule
        {
          prop: 'isSchedule',
          label: '是否有排班',
          body: {
            component: () => import('@/components/Tag/Tag.vue'),
            props: {
              type: isSchedule ? 'action' : 'danger',
            },
            render: () => {
              return isSchedule ? '是' : '否'
            },
          },
        },
        // scheduleDuration
        {
          prop: 'scheduleDuration',
          label: '排班時段長度（分鐘）',
          body: {
            component: () => import('@/components/Tag/Tag.vue'),
            props: {
              type: scheduleDuration > 0 ? 'success' : 'danger',
            },
            render: () => {
              return scheduleDuration
            },
          },
        },
        // isNotBanSchedule
        {
          prop: 'isNotBanSchedule',
          label: '是否沒有關閉時段',
          body: {
            component: () => import('@/components/Tag/Tag.vue'),
            props: {
              type: isNotBanSchedule ? 'action' : 'danger',
            },
            render: () => {
              return isNotBanSchedule ? '是' : '否'
            },
          },
        },
        // bookingCount
        {
          prop: 'bookingCount',
          label: '已預約數量',
          body: {
            component: () => import('@/components/Tag/Tag.vue'),
            props: {
              type: bookingCount > 0 ? 'warning' : 'success',
            },
            render: () => {
              return bookingCount
            },
          },
        },
        // isAvailable
        {
          prop: 'isAvailable',
          label: '是否可預約',
          body: {
            component: () => import('@/components/Tag/Tag.vue'),
            props: {
              type: isAvailable ? 'action' : 'danger',
            },
            render: () => {
              return isAvailable ? '是' : '否'
            },
          },
        },
        // availableDuration
        {
          prop: 'availableDuration',
          label: '可預約時段長度（分鐘）',
          body: {
            component: () => import('@/components/Tag/Tag.vue'),
            props: {
              type: availableDuration > 0 ? 'success' : 'danger',
            },
            render: () => {
              return availableDuration
            },
          },
        },
      ]

      if (isNull(appointmentUnitTimestockData) || isUndefined(appointmentUnitTimestockData)) {
        omitFields.concat([
          'bookingMax',
          'isSchedule',
          'scheduleDuration',
          'isNotBanSchedule',
          'bookingCount',
          'isAvailable',
          'availableDuration',
        ])
      }

      if (isNull(isPubApt) || isUndefined(isPubApt)) {
        omitFields.push('isPubApt')
      }

      return filter(fields, (field) => {
        return !omitFields.includes(field.prop)
      })
    })

    const displayServiceResourceFields = computed(() => {
      const omitFields = []
      const appointmentUnitTimestockData = get(props.resultData, 'resourceItemTimestockData')
      const bookingMax = get(appointmentUnitTimestockData, 'bookingMax')
      const isSchedule = get(appointmentUnitTimestockData, 'isSchedule')
      const scheduleDuration = get(appointmentUnitTimestockData, 'scheduleDuration')
      const isNotBanSchedule = get(appointmentUnitTimestockData, 'isNotBanSchedule')
      const bookingCount = get(appointmentUnitTimestockData, 'bookingCount')
      const isAvailable = get(appointmentUnitTimestockData, 'isAvailable')
      const availableDuration = get(appointmentUnitTimestockData, 'availableDuration')

      const fields = [
        // bookingMax
        {
          prop: 'bookingMax',
          label: '同時段可服務數量',
          body: {
            component: () => import('@/components/Tag/Tag.vue'),
            props: {
              type: 'success',
            },
            render: () => {
              return bookingMax || '-'
            },
          },
        },
        // isSchedule
        {
          prop: 'isSchedule',
          label: '是否有排班',
          body: {
            component: () => import('@/components/Tag/Tag.vue'),
            props: {
              type: isSchedule ? 'action' : 'danger',
            },
            render: () => {
              return isSchedule ? '是' : '否'
            },
          },
        },
        // scheduleDuration
        {
          prop: 'scheduleDuration',
          label: '排班時段長度（分鐘）',
          body: {
            component: () => import('@/components/Tag/Tag.vue'),
            props: {
              type: scheduleDuration > 0 ? 'success' : 'danger',
            },
            render: () => {
              return scheduleDuration || '-'
            },
          },
        },
        // isNotBanSchedule
        {
          prop: 'isNotBanSchedule',
          label: '是否沒有關閉時段',
          body: {
            component: () => import('@/components/Tag/Tag.vue'),
            props: {
              type: isNotBanSchedule ? 'action' : 'danger',
            },
            render: () => {
              return isNotBanSchedule ? '是' : '否'
            },
          },
        },
        // bookingCount
        {
          prop: 'bookingCount',
          label: '已預約數量',
          body: {
            component: () => import('@/components/Tag/Tag.vue'),
            props: {
              type: 'warning',
            },
            render: () => {
              return bookingCount || '-'
            },
          },
        },
        // isAvailable
        {
          prop: 'isAvailable',
          label: '是否可預約',
          body: {
            component: () => import('@/components/Tag/Tag.vue'),
            props: {
              type: isAvailable ? 'action' : 'danger',
            },
            render: () => {
              return isAvailable ? '是' : '否'
            },
          },
        },
        // availableDuration
        {
          prop: 'availableDuration',
          label: '可預約時段長度（分鐘）',
          body: {
            component: () => import('@/components/Tag/Tag.vue'),
            props: {
              type: availableDuration > 0 ? 'success' : 'danger',
            },
            render: () => {
              return availableDuration || '-'
            },
          },
        },
      ]

      if (isNull(appointmentUnitTimestockData) || isUndefined(appointmentUnitTimestockData)) {
        omitFields.concat([
          'bookingMax',
          'isSchedule',
          'scheduleDuration',
          'isNotBanSchedule',
          'bookingCount',
          'isAvailable',
          'availableDuration',
        ])
      }

      return filter(fields, (field) => {
        return !omitFields.includes(field.prop)
      })
    })

    const displayCommonFields = computed(() => {
      const omitFields = []

      const totalBookingTime = get(props.resultData, 'totalBookingTime')
      const resourceItemTotalBookingTime = get(props.resultData, 'resourceItemTotalBookingTime')

      const isTimeUnit = get(props.resultData, 'timeSettingCheck.isTimeUnit')
      const isClientTimeSlot = get(props.resultData, 'timeSettingCheck.isClientTimeSlot')
      const isClientOpen = get(props.resultData, 'timeSettingCheck.isClientOpen')
      const isClientNotClose = get(props.resultData, 'timeSettingCheck.isClientNotClose')

      const fields = [
        {
          prop: 'totalBookingTime',
          label: '人員佔用時間（分鐘）',
          body: {
            component: () => import('@/components/Tag/Tag.vue'),
            props: {
              type: 'warning',
            },
            render: () => {
              return totalBookingTime || '-'
            },
          },
        },
        {
          prop: 'resourceItemTotalBookingTime',
          label: '設備佔用時間（分鐘）',
          body: {
            component: () => import('@/components/Tag/Tag.vue'),
            props: {
              type: 'warning',
            },
            render: () => {
              return resourceItemTotalBookingTime || '-'
            },
          },
        },
        // isTimeUnit 開始時間是否符合時間間隔、時段偏移
        {
          prop: 'isTimeUnit',
          label: '開始時間是否符合時間間隔、時段偏移',
          body: {
            component: () => import('@/components/Tag/Tag.vue'),
            props: {
              type: isTimeUnit ? 'action' : 'danger',
            },
            render: () => {
              return isTimeUnit ? '是' : '否'
            },
          },
        },
        // isClientTimeSlot 開始時間是否為 Client 允許顯示時段
        {
          prop: 'isClientTimeSlot',
          label: '開始時間是否為 Client 允許顯示時段',
          body: {
            component: () => import('@/components/Tag/Tag.vue'),
            props: {
              type: isClientTimeSlot ? 'action' : 'danger',
            },
            render: () => {
              return isClientTimeSlot ? '是' : '否'
            },
          },
        },
        // isClientOpen 是否已達 Client 最早開放時間
        {
          prop: 'isClientOpen',
          label: '是否已達 Client 最早開放時間',
          body: {
            component: () => import('@/components/Tag/Tag.vue'),
            props: {
              type: isClientOpen ? 'action' : 'danger',
            },
            render: () => {
              return isClientOpen ? '是' : '否'
            },
          },
        },
        // isClientNotClose 是否未達 Client 最晚可預約時間
        {
          prop: 'isClientNotClose',
          label: '是否未達 Client 最晚可預約時間',
          body: {
            component: () => import('@/components/Tag/Tag.vue'),
            props: {
              type: isClientNotClose ? 'action' : 'danger',
            },
            render: () => {
              return isClientNotClose ? '是' : '否'
            },
          },
        },
      ]

      return filter(fields, (field) => {
        return !omitFields.includes(field.prop)
      })
    })

    return {
      showControl,
      displayServiceAttachs,
      displayServiceFields,
      displayServiceUnitFields,
      displayServiceResourceFields,
      displayCommonFields,
    }
  },
})
</script>

<style lang="postcss" scoped>

</style>
